<ng-container *ngIf="info$ | async as info">
  <app-restricted-content-dialog [featureInfo]="info"></app-restricted-content-dialog>
</ng-container>
